/**
 * apiのドメイン
 */
// const baseUrl_RELEASE = "https://xs591901.xsrv.jp/api/admin";
const baseUrl_RELEASE = 'https://api.ssa-app.com/api/admin';

const baseUrl_TRN = 'https://tran-it.biz/foster/laravel/public/api/admin';
// const baseUrl_DEVELOP = 'http://localhost/api/admin';
// const baseUrl_LOCAL = "http://192.168.128.54/api/admin";
const baseUrl_LOCAL = 'http://localhost/api/admin';

/**
 * アドミンシステム
 */
export const adminUrl = 'https://admin.ssa-app.com';

/**
 * 一般システム
 */
export const ssaUrl = 'https://ssa-app.com';

/**
 * 動作モードの定数
 * RELEASE: 本番モード
 * LOCAL: 開発モード(ローカル環境)
 * TRN: 開発モード(TRN環境)
 */
export const AppModeType = {
  /** 本番モード */
  RELEASE: 1,
  /** 開発モード(ローカル環境) */
  LOCAL: 2,
  /** 開発モード(TRN環境) */
  TRN: 3,
};
export type AppModeType = (typeof AppModeType)[keyof typeof AppModeType];
/**
 * 動作モード
 * 環境変数 REACT_APP_APP_MODE（'LOCAL' | 'TRN'）が設定されていればそちらを優先する。
 * 未設定時は従来どおり RELEASE（本番）で動作する。
 */
function resolveAppModeType(): AppModeType {
  switch (process.env.REACT_APP_APP_MODE) {
    case 'LOCAL':
      return AppModeType.LOCAL;
    case 'TRN':
      return AppModeType.TRN;
    default:
      return AppModeType.RELEASE;
  }
}

// const appModeType: AppModeType = AppModeType.LOCAL;
const appModeType: AppModeType = resolveAppModeType();
export const appVersion = '2026.04.09.01';

export function APP_MODE_COLOR() {
  switch (appModeType) {
    case AppModeType.LOCAL:
      return '#F00';

    case AppModeType.RELEASE:
      return '#FFF';

    default:
      return '#666';
  }
}

//apiのドメインを設定する。
export function baseURL() {
  // ローカル docker の公開ポートは環境ごとに異なる（例: PORT_BASE=6 の環境では http://localhost:6812）。
  // 環境変数 REACT_APP_API_BASE_URL が設定されていれば最優先で使う。
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }

  let baseUrl: string;

  switch (appModeType) {
    case AppModeType.LOCAL:
      baseUrl = baseUrl_LOCAL;
      break;
    case AppModeType.RELEASE:
      baseUrl = baseUrl_RELEASE;
      break;
    case AppModeType.TRN:
      baseUrl = baseUrl_TRN;
      break;
    default:
      throw new Error('Invalid app mode type');
  }

  return baseUrl;
}
